import { render } from "./BankTransfer.vue?vue&type=template&id=1adc9954&scoped=true"
import script from "./BankTransfer.vue?vue&type=script&lang=js"
export * from "./BankTransfer.vue?vue&type=script&lang=js"

import "./BankTransfer.vue?vue&type=style&index=0&id=1adc9954&lang=less&scoped=true"
import "./BankTransfer.vue?vue&type=style&index=1&id=1adc9954&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adc9954"]])

export default __exports__